import { useContext } from "react";
import { FormContext } from "./CMSRenderer";
import { StaticTable } from "./renderer";
import { getStaticCategory } from "../../utils/apiCalls";

// export const getNestedValue = (obj, path = []) => {
//   return path.reduce((acc, key) => {
//     const realKey = !isNaN(key) ? parseInt(key, 10) : key;
//     return acc && acc[realKey] !== undefined ? acc[realKey] : undefined;
//   }, obj);
// };

export const getNestedValue = (obj, path = []) => {
  const resolve = (current, subPath) => {
    if (!current) return undefined;
    if (subPath.length === 0) return current;

    const [key, ...restPath] = subPath;

    // Check [combine]
    if (key === "[combine]") {
      if (!Array.isArray(current)) return undefined;

      const combinedResults = current
        .map((item) => resolve(item, restPath))
        .filter((v) => v !== undefined);

      return combinedResults.join("\n");
    }

    // Check [a, b]
    const arrayKeyMatch = key.match(/^\[(.+)\]$/);
    if (arrayKeyMatch) {
      const innerKeys = arrayKeyMatch[1].split(",").map((k) => k.trim());

      // Check if only one key and it is numeric (e.g., "[0]")
      if (innerKeys.length === 1 && !isNaN(innerKeys[0])) {
        const index = parseInt(innerKeys[0], 10);
        return current[index] !== undefined
          ? resolve(current[index], restPath)
          : undefined;
      }

      // Otherwise, combine keys
      const values = innerKeys
        .map((k) => current[k])
        .filter((v) => v !== undefined);
      return values.join(", ");
    }

    // Normal key or numeric
    const realKey = !isNaN(key) ? parseInt(key, 10) : key;
    return current[realKey] !== undefined
      ? resolve(current[realKey], restPath)
      : undefined;
  };

  return resolve(obj, path);
};

export const safeParseJSON = (input) => {
  try {
    return JSON.parse(input);
  } catch (err) {
    console.error("Invalid JSON:", err.message);
    return {}; // or return input; depending on fallback behavior
  }
};

export const getValue = ({ type_identifier = {}, currentElement = {} }) => {
  console.log("getValue", type_identifier, currentElement);

  return type_identifier?.helper === "JSON"
    ? JSON.stringify(getNestedValue(currentElement, type_identifier?.params))
    : getNestedValue(currentElement, type_identifier?.params);
};

export const getDataFromAPI = async ({
  setConfiguration,
  configuration,
  config = {},
  page = 1,
  pageSize = 10,
}) => {
  const result = await getStaticCategory({
    page: 1,
    pageSize: 10,
    url: config?.data_source,
  });

  const childValue = config?.parent_params
    ? getValue({
      type_identifier: { params: JSON.parse(config?.parent_params) || {} },
      currentElement: result,
    })
    : result;
  setConfiguration({
    ...configuration,
    [`${config?._id}_data`]: childValue || [],
  });
  return childValue;
};

export const getTranlation = ({ config }) => {
  let tempConfig = { ...config };
  if (tempConfig?.text_ar) {
    tempConfig = {
      ...tempConfig,
      text: tempConfig?.text_ar ? tempConfig?.text_ar : tempConfig.text,
    };
  }
  if (tempConfig?.onDownload_ar) {
    tempConfig = {
      ...tempConfig,
      text: tempConfig?.onDownload_ar ? tempConfig?.onDownload_ar : tempConfig.onDownload,
    };
  }
  if (tempConfig?.title_ar) {
    tempConfig = {
      ...tempConfig,
      title: tempConfig?.title_ar ? tempConfig?.title_ar : tempConfig.title,
    };
  }
  if (tempConfig?.linker_ar) {
    tempConfig = {
      ...tempConfig,
      linker: tempConfig?.linker_ar ? tempConfig?.linker_ar : tempConfig.linker,
    };
  }
  if (tempConfig?.description_ar) {
    tempConfig = {
      ...tempConfig,
      description: tempConfig?.description_ar
        ? tempConfig?.description_ar
        : tempConfig.description,
    };
  }
  if (tempConfig?.fileName_ar) {
    tempConfig = {
      ...tempConfig,
      fileName: tempConfig?.fileName_ar
        ? tempConfig?.fileName_ar
        : tempConfig.fileName,
    };
  }
  if (tempConfig?.name_ar) {
    tempConfig = {
      ...tempConfig,
      name: tempConfig?.name_ar ? tempConfig?.name_ar : tempConfig.name,
    };
  }
  if (tempConfig?.label_ar) {
    tempConfig = {
      ...tempConfig,
      label: tempConfig?.label_ar ? tempConfig?.label_ar : tempConfig.label,
    };
  }
  if (tempConfig?.text_params_ar) {
    tempConfig = {
      ...tempConfig,
      text_params: tempConfig?.text_params_ar
        ? tempConfig?.text_params_ar
        : tempConfig.text_params,
    };
  }
  if (tempConfig?.accordion_icon_text_ar) {
    tempConfig = {
      ...tempConfig,
      accordion_icon_text: tempConfig?.accordion_icon_text_ar
        ? tempConfig?.accordion_icon_text_ar
        : tempConfig.accordion_icon_text,
    };
  }
  if (tempConfig?.header_text_ar) {
    tempConfig = {
      ...tempConfig,
      header_text: tempConfig?.header_text_ar
        ? tempConfig?.header_text_ar
        : tempConfig.header_text,
    };
  }
  if (tempConfig?.sub_title_ar) {
    tempConfig = {
      ...tempConfig,
      sub_title: tempConfig?.sub_title_ar
        ? tempConfig?.sub_title_ar
        : tempConfig.sub_title,
    };
  }
  if (tempConfig?.body_description_ar) {
    tempConfig = {
      ...tempConfig,
      body_description: tempConfig?.body_description_ar
        ? tempConfig?.body_description_ar
        : tempConfig.body_description,
    };
  }
  if (tempConfig?.link_button_text_ar) {
    tempConfig = {
      ...tempConfig,
      link_button_text: tempConfig?.link_button_text_ar
        ? tempConfig?.link_button_text_ar
        : tempConfig.link_button_text,
    };
  }
  if (tempConfig?.button_name_ar) {
    tempConfig = {
      ...tempConfig,
      button_name: tempConfig?.button_name_ar
        ? tempConfig?.button_name_ar
        : tempConfig.button_name,
    };
  }
  if (tempConfig?.title_params_ar) {
    tempConfig = {
      ...tempConfig,
      title_params: tempConfig?.title_params_ar
        ? tempConfig?.title_params_ar
        : tempConfig.title_params,
    };
  }
  if (tempConfig?.button_text_ar) {
    tempConfig = {
      ...tempConfig,
      button_text: tempConfig?.button_text_ar
        ? tempConfig?.button_text_ar
        : tempConfig.button_text,
    };
  }
  if (tempConfig?.button_name_ar) {
    tempConfig = {
      ...tempConfig,
      button_name: tempConfig?.button_name_ar
        ? tempConfig?.button_name_ar
        : tempConfig.button_name,
    };
  }
  if (tempConfig?.team_member_position_ar) {
    tempConfig = {
      ...tempConfig,
      team_member_position: tempConfig?.team_member_position_ar
        ? tempConfig?.team_member_position_ar
        : tempConfig.team_member_position,
    };
  }
  if (tempConfig?.team_member_name_ar) {
    tempConfig = {
      ...tempConfig,
      team_member_name: tempConfig?.team_member_name_ar
        ? tempConfig?.team_member_name_ar
        : tempConfig.team_member_name,
    };
  }
  if (tempConfig?.linkButtonText_ar) {
    tempConfig = {
      ...tempConfig,
      linkButtonText: tempConfig?.linkButtonText_ar
        ? tempConfig?.linkButtonText_ar
        : tempConfig.linkButtonText,
    };
  }
  if (tempConfig?.banner_card_title_ar) {
    tempConfig = {
      ...tempConfig,
      banner_card_title: tempConfig?.banner_card_title_ar
        ? tempConfig?.banner_card_title_ar
        : tempConfig.banner_card_title,
    };
  }
  if (tempConfig?.banner_card_description_ar) {
    tempConfig = {
      ...tempConfig,
      banner_card_description: tempConfig?.banner_card_description_ar
        ? tempConfig?.banner_card_description_ar
        : tempConfig.banner_card_description,
    };
  }
  if (tempConfig?.body_text_ar) {
    tempConfig = {
      ...tempConfig,
      body_text: tempConfig?.body_text_ar
        ? tempConfig?.body_text_ar
        : tempConfig.body_text,
    };
  }
  if (tempConfig?.price_text_ar) {
    tempConfig = {
      ...tempConfig,
      price_text: tempConfig?.price_text_ar
        ? tempConfig?.price_text_ar
        : tempConfig.price_text,
    };
  }
  if (tempConfig?.left_button_name_ar) {
    tempConfig = {
      ...tempConfig,
      left_button_name: tempConfig?.left_button_name_ar
        ? tempConfig?.left_button_name_ar
        : tempConfig.left_button_name,
    };
  }
  if (tempConfig?.right_button_name_ar) {
    tempConfig = {
      ...tempConfig,
      right_button_name: tempConfig?.right_button_name_ar
        ? tempConfig?.right_button_name_ar
        : tempConfig.right_button_name,
    };
  }
  if (tempConfig?.image_chip_label_ar) {
    tempConfig = {
      ...tempConfig,
      image_chip_label: tempConfig?.image_chip_label_ar
        ? tempConfig?.image_chip_label_ar
        : tempConfig.image_chip_label,
    };
  }
  if (tempConfig?.banner_card_name_ar) {
    tempConfig = {
      ...tempConfig,
      banner_card_name: tempConfig?.banner_card_name_ar
        ? tempConfig?.banner_card_name_ar
        : tempConfig.banner_card_name,
    };
  }
  if (tempConfig?.chip_text_ar) {
    tempConfig = {
      ...tempConfig,
      chip_text: tempConfig?.chip_text_ar
        ? tempConfig?.chip_text_ar
        : tempConfig.chip_text,
    };
  }
  if (tempConfig?.href_ar) {
    tempConfig = {
      ...tempConfig,
      href: tempConfig?.href_ar
        ? tempConfig?.href_ar
        : tempConfig.href,
    };
  }
  if (tempConfig?.props) {
    return {
      ...tempConfig,
      props: getTranlation({ config: tempConfig?.props }),
    };
  }
  if (typeof tempConfig?.title === "object") {
    return {
      ...tempConfig,
      props: getTranlation({ config: tempConfig?.title }),
    };
  }
  if (tempConfig?.breadCrumb_item) {
    const updatedCrumbs = tempConfig.breadCrumb_item.map((crumb) =>
      getTranlation({ config: crumb })
    );
    return {
      ...tempConfig,
      breadCrumb_item: updatedCrumbs,
    };
  }
  if (tempConfig?.["chip_list"]) {
    const updatedChiplist = tempConfig?.["chip_list"].map((crumb) =>
      getTranlation({ config: crumb })
    );
    return {
      ...tempConfig,
      ["chip_list"]: updatedChiplist,
    };
  }
  if (tempConfig?.detail) {
    const updatedDetail = tempConfig.detail.map((crumb) =>
      getTranlation({ config: crumb })
    );
    return {
      ...tempConfig,
      detail: updatedDetail,
    };
  }
  if (tempConfig?.bannerCard) {
    const updatedbannerCard = tempConfig.bannerCard.map((crumb) =>
      getTranlation({ config: crumb })
    );
    return {
      ...tempConfig,
      bannerCard: updatedbannerCard,
    };
  }

  return tempConfig;
};
